(() => {
const restrictedVariantId = 51038536434011;

function enforceSingleQuantity() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const restrictedItem = cart.items.find(item => item.variant_id === restrictedVariantId);

      if (restrictedItem && restrictedItem.quantity > 1) {
        console.warn(`⚠️ Gratisartikel war ${restrictedItem.quantity}× im Warenkorb – setze auf 1.`);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: restrictedItem.key,
            quantity: 1
          })
        }).then(() => location.reload());
      }
    });
}

setInterval(enforceSingleQuantity, 200);
})();
